import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import config from '../functions/config';

function PurchaseHistoryPage() {
  const [purchaseHistory, setPurchaseHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const sessionId = Cookies.get('sessionid');
    console.log("purchase ID:", sessionId);

    // Check if the session ID exists, indicating the user is logged in
    if (sessionId) {
      fetchPurchaseHistory(sessionId);
    } else {
      setError('User not authenticated. Please log in.');
      setLoading(false);
    }
  }, []);

  const fetchPurchaseHistory = async (sessionId) => {
    try {
      const response = await axios.get(`${config.BASE_URL}/api/purchasehistory/`, {
        headers: {
          'X-Session-ID': sessionId, // Include session ID in the request headers
        },
      });
      if (response.status === 200) {
        setPurchaseHistory(response.data);
        console.log(response.data);  // ✅ Log the data

        setLoading(false);
      } else {
        throw new Error('Failed to fetch purchase history');
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        // Handle unauthorized access error
        setError('Unauthorized access. Please log in again.');
      } else {
        // General error handling
        setError('Error fetching purchase history. Please try again later.');
      }
      setLoading(false);
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>{error}</div>;

  return (
    <div>
      {/* Fixed Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">Library Management</a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
            <li className="nav-item">
                <a className="nav-link" href="/success">
                   Books
                </a>
              </li>
            <li className="nav-item">
                <a className="nav-link" href="/userhome">Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/profile">Profile</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/rentalhistory">Rented Books</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" href="/purchasehistory">Purchase History</a>
              </li>
              <li className="nav-item">
                <a href="/login" className="btn btn-danger">Logout</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>

      {/* Purchase History Table */}
      <div className="my-5 pt-5 container" style={{ marginTop: '80px' }}>
        <h2 className="text-center mb-4">Purchase History</h2>
        <div className="table-responsive">
          <table className="table table-bordered table-striped">
            <thead className="table-dark">
              <tr>
                <th>Book</th>
                <th>Quantity</th>
                <th>Total Price</th>
                <th>Purchase Date</th>
                <th>Address</th>
                <th>Phone Number</th>
              </tr>
            </thead>
            <tbody>
              {purchaseHistory.map((purchase, index) => (
                <tr key={index}>
                  <td>{purchase.book}</td>
                  <td>{purchase.quantity}</td>
                  <td>Rs . {purchase.total_price}</td>
                  <td>{new Date(purchase.purchase_date).toLocaleDateString()}</td>
                  <td>{purchase.address}</td>
                  <td>{purchase.phone_number}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default PurchaseHistoryPage;
